export default __webpack_public_path__ + "static/media/tradelocker_nameless.e7aff5df.svg";